export default function CourseTree (courseTree) {

  let containers;
  let contents;

  const traverse = (node, parentNumber) => {
    if (node.type == 'container') {
      containers.push(node)
    } else if (node.type == 'content') {
      contents.push(node)
    }
    if (node.child_nodes && node.child_nodes.length) {
      let number = 1
      for(let i = 0; i < node.child_nodes.length; i++) {
        const child_node = node.child_nodes[i]
        if (child_node.type == 'container') {
          child_node.number = !!parentNumber ? `${parentNumber}.${number}` : `${number}`
          number++
        }
        traverse(child_node, child_node.number)
      }
    }
  }

  const self = {
    refresh: () => {
      containers = [courseTree]
      contents = []
      traverse(courseTree)
    },
    findNode: (nodeId) => {
      const nodeFound = containers.find((container) => container.id == nodeId)
      if (nodeFound) {
        return nodeFound
      }
      return contents.find((content) => content.id == nodeId)
    },
    findParent: (nodeId) => {
      for(let i = 0; i < containers.length; i++) {
        let container = containers[i]
        for(let j = 0; j < container.child_nodes.length; j++) {
          let child_node = container.child_nodes[j]
          if (child_node.id == nodeId) {
            return container
          }
        }
      }
    },
    updatePositions: (parentNode) => {
      for(let i = 0; i < parentNode.child_nodes.length; i++) {
        parentNode.child_nodes[i].position = i
      }
    },
    removeNode: (nodeId) => {
      const parentNode = self.findParent(nodeId)
      const index = parentNode.child_nodes.findIndex((q) => q.id == nodeId)
      const removedNode = parentNode.child_nodes.splice(index, 1).pop()
      self.updatePositions(parentNode)
      self.refresh()
      return removedNode
    },
    addNode: (parentNode, node, index) => {
      node.parent_node_id = parentNode.id
      node.parent_node_type = parentNode.type == 'container' ? 'Node' : 'CourseTree'
      if (!parentNode.child_nodes) {
        parentNode.child_nodes = []
      }
      parentNode.child_nodes.splice(index, 0, node)
      self.updatePositions(parentNode)
      self.refresh()
    },
    prependNode: (beforeNodeId, node) => {
      const parentNode = self.findParent(beforeNodeId)
      const index = parentNode.child_nodes.findIndex((q) => q.id == beforeNodeId)
      self.addNode(parentNode, node, index)
      return node
    },
    appendNode: (afterNodeId, node) => {
      const parentNode = self.findParent(afterNodeId)
      const index = parentNode.child_nodes.findIndex((q) => q.id == afterNodeId)
      self.addNode(parentNode, node, index + 1)
      return node
    },
    updateNode: (node) => {
      const nodeFound = self.findNode(node.id)
      if (nodeFound) {
        for (const property in node) {
          nodeFound[property] = node[property]
        }
      }
    },
    contents: () => contents,
    props: courseTree
  }

  self.refresh();

  return Object.assign({}, courseTree, self)
}
